import {useEffect} from 'react'
import {useParams, useNavigate} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const usePutAdvertise = (srcState, videoState, type) => {
	const navigate = useNavigate()
	const {idx} = useParams()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const request = () => {
		fetchRequest('PUT', `/admin/advertise-timer/${idx}`, {
			src: type === 'image' ? srcState : videoState,
			type: type,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				navigate(-1)
				break
			case 400:
				if (fetchResult?.data?.error_code === 'ad_idx')
					setAlert('타이머 광고 idx를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'src')
					setAlert('첨부파일을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('타이머 광고 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [request]
}

export default usePutAdvertise
